<template>
  <div>
    <base-fieldset>
      <base-input
        v-model.trim="orderDeliveryNo"
        size="sm"
        label="delivery_order_number"
        clearable
      />
    </base-fieldset>
    <base-fieldset>
      <base-input v-model.trim="orderClientNo" size="sm" label="client_order_number" clearable />
    </base-fieldset>
    <base-fieldset>
      <CompanySelect :filterArray="orderCompany" />
    </base-fieldset>
    <base-fieldset>
      <base-input
        v-model.trim="orderSalesRepresentative"
        size="sm"
        label="representative"
        clearable
      />
    </base-fieldset>
  </div>
</template>

<script>
import {BaseFieldset, BaseInput} from '@/components/base'
import CompanySelect from '@/components/shared/CompanySelect.vue'
import _isEmpty from "lodash-es/isEmpty";

export default {
  components: {
    BaseFieldset,
    BaseInput,
    CompanySelect
  },
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      orderDeliveryNo: this.$route.query.delivery_order_number || '',
      orderClientNo: this.$route.query.client_order_number || '',
      orderCompany: this.$route.query.company ? [...this.$route.query.company] : [],
      orderSalesRepresentative: this.$route.query.sales_representative || '',
    }
  },
  methods: {
    submit() {
      this.$store.dispatch('app/filterProp', {
        value: [
          this.orderDeliveryNo,
          this.orderClientNo,
          this.orderCompany,
          this.orderSalesRepresentative,
        ],
        name: ['delivery_order_number', 'client_order_number', 'company', 'sales_representative'],
      })
    },
    reset() {
      this.orderDeliveryNo = ''
      this.orderClientNo = ''
      this.orderCompany = []
      this.orderSalesRepresentative = ''
      this.$router.push({name: 'Orders', query: {}})
    },
  },
  computed: {
    isGwf() {
      return (
        !this.$store.getters['auth/currentUser'].companies ||
        this.$store.getters['auth/currentUser'].companies.length === 0
      )
    },
  },
  watch: {
    $route (n, o) { if (_isEmpty(n.query)) { this.reset(); } },
    orderDeliveryNo(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'delivery_order_number'})
    },
    orderClientNo(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'client_order_number'})
    },
    orderCompany(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'company'})
    },
    orderSalesRepresentative(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'sales_representative'})
    }
  },
}
</script>
